import { useMemo } from "react";
import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import Typography from "@mui/material/Typography";
import { CBBundleStep, CBOmissionType, IBundleInfoRowData, IBundleInfoValues } from "../../../../types";
import { useTranslation } from "react-i18next";
import { cbDateFormat } from "../../../../utils";

interface CBBundleInfoGridProps {
    bundleInfo: IBundleInfoValues
}

const CBBundleInfoGrid = ({ bundleInfo }: CBBundleInfoGridProps) => {

    const { t } = useTranslation("customerbase");

    const columnDefs = useMemo<ColDef[]>(() => {
        return [
            {
                headerName: "",
                field: "field",
                lockPosition: "left",
                suppressMovable: true,
                cellStyle: {'backgroundColor': '#f8f8f8'},
                cellRenderer: (params: ICellRendererParams) => {
                    return (
                        <Typography variant="h6">{t(`${params?.data?.field}`, '')}</Typography>
                    )
                }
            },
            {
                headerName: t("labels.ocrInfo"),
                field: "ocr",
                resizable: true
                //cellStyle: {/*'borderBottom': '1px solid #dde2eb'*/ 'overflowX': 'scroll'}
            },
            {
                headerName: t("labels.userInfo"),
                field: "user",
                resizable: true
                //cellStyle: {'borderBottom': '1px solid #dde2eb'}
            }
        ];
    }, [t]);

    const rowData = useMemo<IBundleInfoRowData[]>(() => {
        if(bundleInfo.step?.toUpperCase() == CBBundleStep.DRIVING_LICENCE) {
            return [
                {field: 'firstName', ocr: bundleInfo.ocrInfo?.firstName || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.firstName || CBOmissionType.OMISSION_DASH},
                {field: 'lastName', ocr: bundleInfo.ocrInfo?.lastName || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.lastName || CBOmissionType.OMISSION_DASH},
                {field: 'birthDate', ocr: cbDateFormat(bundleInfo.ocrInfo?.dateOfBirth || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH, user: cbDateFormat(bundleInfo.usrInfo?.dateOfBirth || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH},
                {field: 'birthMunicipality', ocr: bundleInfo.ocrInfo?.birthMunicipality || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.birthMunicipality || CBOmissionType.OMISSION_DASH},
                {field: 'birthProvince', ocr: bundleInfo.ocrInfo?.birthProvince || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.birthProvince || CBOmissionType.OMISSION_DASH},
                {field: 'idNumber', ocr: bundleInfo.ocrInfo?.idDocument || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.idDocument || CBOmissionType.OMISSION_DASH},
                {field: 'releaseDate', ocr: cbDateFormat(bundleInfo.ocrInfo?.issueDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH, user: cbDateFormat(bundleInfo.usrInfo?.issueDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH},
                {field: 'expireDate', ocr: cbDateFormat(bundleInfo.ocrInfo?.expireDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH, user: cbDateFormat(bundleInfo.usrInfo?.expireDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH},
                {field: 'category', ocr: bundleInfo.ocrInfo?.licenseCategory || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.licenseCategory || CBOmissionType.OMISSION_DASH},
                {field: 'issuingPlace', ocr: bundleInfo.ocrInfo?.placeOfIssue || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.placeOfIssue || CBOmissionType.OMISSION_DASH},
                {field: 'issuingAuthority', ocr: bundleInfo.ocrInfo?.releasedBy || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.releasedBy || CBOmissionType.OMISSION_DASH}  
            ];
        }
        return [
            {field: 'firstName', ocr: bundleInfo.ocrInfo?.firstName || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.firstName || CBOmissionType.OMISSION_DASH},
            {field: 'lastName', ocr: bundleInfo.ocrInfo?.lastName || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.lastName || CBOmissionType.OMISSION_DASH},
            {field: 'birthDate', ocr: cbDateFormat(bundleInfo.ocrInfo?.dateOfBirth || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH, user: cbDateFormat(bundleInfo.usrInfo?.dateOfBirth || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH},
            {field: 'birthMunicipality', ocr: bundleInfo.ocrInfo?.birthMunicipality || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.birthMunicipality || CBOmissionType.OMISSION_DASH},
            {field: 'birthProvince', ocr: bundleInfo.ocrInfo?.birthProvince || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.birthProvince || CBOmissionType.OMISSION_DASH},
            {field: 'idNumber', ocr: bundleInfo.ocrInfo?.idDocument || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.idDocument || CBOmissionType.OMISSION_DASH},
            {field: 'releaseDate', ocr: cbDateFormat(bundleInfo.ocrInfo?.issueDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH, user: cbDateFormat(bundleInfo.usrInfo?.issueDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH},
            {field: 'expireDate', ocr: cbDateFormat(bundleInfo.ocrInfo?.expireDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH, user: cbDateFormat(bundleInfo.usrInfo?.expireDate || '', "DD/MM/YYYY") || CBOmissionType.OMISSION_DASH},
            {field: 'issuingPlace', ocr: bundleInfo.ocrInfo?.placeOfIssue || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.placeOfIssue || CBOmissionType.OMISSION_DASH},
            {field: 'issuingAuthority', ocr: bundleInfo.ocrInfo?.releasedBy || CBOmissionType.OMISSION_DASH, user: bundleInfo.usrInfo?.releasedBy || CBOmissionType.OMISSION_DASH}
            
        ];
    }, [bundleInfo]);

    /*const getRowStyle = (_params: any) => {
        return {border: 'none'}
    }*/

    return (
        <>
            <AgGridCustomTable 
                rowData={rowData}
                rowModelType="clientSide"
                columnDefs={columnDefs}
                pagination={false}
                rowStyle={{
                    cursor: 'pointer'
                }}
                //getRowStyle={getRowStyle}
            />
        </>
    )
}

export default CBBundleInfoGrid;